import Link from "next/link";
import type { BoardOffSeason } from "./board-area-model";

/**
 * Snow boards when most resorts are closed for the season (forecast areas spec, section 10.2):
 * one line with the usual opening month and a link to the best time to go. The rows stay as
 * they are below it.
 */
export function BoardOffSeasonBanner({ offSeason }: { offSeason: BoardOffSeason }) {
  return (
    <p
      className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-[12px] border border-sky-200 bg-sky-50 px-4 py-3 text-[13px] text-sky-900"
      data-board-off-season
    >
      <span>{offSeason.message}</span>
      <Link
        href={offSeason.href}
        className="inline-flex min-h-11 items-center font-semibold text-sky-900 underline decoration-sky-400 underline-offset-2 hover:decoration-sky-700"
      >
        {offSeason.linkLabel}
      </Link>
    </p>
  );
}
